'use strict'

import axios from 'axios'
import store from "../store";
import Axios from '../core/axios';

export default class Change {
  static protocol(protocol) {
    return Axios.post('protocol', {
      protocol
    })
  }

  static validateProtocol(protocol) {
    return Axios.get('validateProtocol', {
      headers: {
        'access_key': store.getters.getAccessKey,
        'metadata': store.getters.getMetadataCookie
      },
      params: {
        'protocol': protocol,
        'clientType': 'PF'
      }
    })
  }

  static loadAuthenticityQuestion(step) {
    return axios.get('/api/auth-question', {
      params: {
        step
      }
    })
  }

  static checkAuthenticityQuestion(step, answer) {
    return axios.post('/api/auth-question', {
      step,
      answer
    })
  }
}
